module.exports = __webpack_public_path__ + "img/BRCA1_Plasma.938f0095.png";